/* eslint-disable no-undef */
$(document).ready(function () {
})



// WEBPACK FOOTER //
// ./src/assets/js/script.js